export class FieldProperty {
  displayText: string;
  isVisible: boolean;
  tooltip: string;

  constructor(data?: FieldProperty) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.displayText = '';
      this.isVisible = true;
      this.tooltip = '';
    }
  }

}
export class MenuConfig {
  addField: FieldProperty;
  editField: FieldProperty;
  details: FieldProperty;
  deleteField: FieldProperty;
  includeExcludeField: FieldProperty;
  conditions: FieldProperty;
  moveField: FieldProperty;
  addSnippet: FieldProperty;
  addMapQuestion: FieldProperty;
  manageSubFields: FieldProperty;
  manageFormula: FieldProperty;
  viewFormula: FieldProperty;
  manageCountry: FieldProperty;
  menuVisibility: FieldProperty;

  constructor(data?: MenuConfig) {
  if (data) {
  Object.assign(this, data);
} else {
  this.addField = new FieldProperty({
    tooltip: 'Note: Adding a Question or Sub-Question to your Data Survey means any responses given are for reference only, and will not be stored inside ITP.',
    isVisible: true,
    displayText: 'Add Field'});
  this.editField = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Edit Field'});
  this.details = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Details & Instructions'});
  this.deleteField = new FieldProperty({ tooltip: '', isVisible: true, displayText: 'Delete Field'});
  this.includeExcludeField = new FieldProperty({ tooltip: '', isVisible: true, displayText: 'Include or Exclude Field'});
  this.conditions = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Conditions'});
  this.moveField = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Move Field'});
  this.addSnippet = new FieldProperty({tooltip: '', isVisible: false, displayText: 'Add Snippet'});
  this.addMapQuestion = new FieldProperty({tooltip: '', isVisible: false, displayText: 'Map Question'});
  this.manageSubFields = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Manage Subfields'});
  this.manageFormula = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Manage Formula'});
  this.viewFormula = new FieldProperty({tooltip: '', isVisible: true, displayText: 'View Formula'});
  this.manageCountry = new FieldProperty({tooltip: '', isVisible: false, displayText: 'Manage Country'});
  this.menuVisibility = new FieldProperty({tooltip: '', isVisible: true, displayText: 'Menu Config Visibility'});
}
}
}
